import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checked_icon",
  "use": "icon-checked_icon-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"icon-checked_icon\">\n  <defs>\n    <style>\n      #icon-checked_icon .cls-1 {\n        fill: #f7e5cb;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"m5.79,11c-.25,0-.49-.09-.68-.27l-3.79-3.5c-.41-.37-.43-1.01-.06-1.41.37-.4,1.01-.43,1.41-.06l3.03,2.8,4.53-5.22c.36-.42,1-.46,1.41-.1.42.36.46.99.1,1.41l-5.21,6c-.18.21-.43.33-.7.34-.02,0-.04,0-.06,0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/checked_icon.svg
// module id = 8KMo
// module chunks = 87